import React, {useState} from "react";
import ScholarshipDetailInfo from "./ScholarshipDetailInfo"
import { useTranslation } from 'react-i18next';

export default function ScholarshipInfo({scholarship, onSaveSholarshipClick, onRemoveScholarshipClick, isInMyList}) {
    const { t } = useTranslation();
    const [ showDetailInfo, setShowDetailInfo ] = useState(false);

    return (
        <li key={scholarship.id} id={`scholarship-${scholarship.id}`} className="list-group-item">
            <div className="row">

                <div className="col-7">
                    <h2 className="small-header">{scholarship.namn}</h2>
                    <p className="card-text mb-0">
                        {(scholarship.kategori !== t('scholarship.categories.nation') && scholarship.kategori !== t('scholarship.categories.faculty')) &&
                           <span>{scholarship.kategori}</span>
                        }
                    </p>
                    <p className="card-text mb-0">
                        {(scholarship.nationer.length > 0 || scholarship.fakulteter.length > 0) &&
                            <span>{scholarship.nationer.concat(scholarship.fakulteter).join(', ')}</span>
                        }
                    </p>
                    {scholarship.utlyst &&
                        <small className="text-muted">{t('scholarship.open_till')} {scholarship.ansokningsdatum}</small>
                    }
                </div>
                
                {scholarship.utlyst &&
                    <div className="col-5">
                        {isInMyList 
                            ? <button className="button-align-right button-outline button-small button-icon icon-remove float-end" onClick={() => onRemoveScholarshipClick()}>{t('scholarship.remove_from_my_list')}</button>
                            : <button className="button-align-right button-outline button-small button-icon icon-add float-end" onClick={() => onSaveSholarshipClick()}>{t('scholarship.save_to_my_list')}</button>
                        }
                    </div>
                }
                {!scholarship.utlyst &&
                <div className="col-5">
                    <small className="float-end">{t('scholarship.currently_not_open')}</small>
                </div>
                }
            </div>
            <div className="row">
                <div className="col-md-12 mb-2 mt-3">
                    <button className="toggle-button button-align-left button-text button-icon" data-bs-toggle="collapse"
                            data-bs-target={"#toggle-" + scholarship.id} aria-controls="toggle-2" aria-expanded="false" onClick={() => setShowDetailInfo(!showDetailInfo)}>
                        <span className="toggle-button-text-collapsed">{t('scholarship.show_scholarship_info')}</span>
                        <span className="toggle-button-text-expanded">{t('scholarship.hide_scholarship_info')}</span>
                    </button>
                </div>
                <div className="col-md-12">
                    <div id={"toggle-" + scholarship.id} className="toggle-content collapse mb-2 mt-3">
                        { showDetailInfo &&
                            <ScholarshipDetailInfo scholarship={scholarship}/>
                        }
                    </div>
                </div>
            </div>
        </li>
    )
}